export default {
      id: "ignition-on-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "img/icons.svg#ignition-on",
      toString: function () {
        return this.url;
      }
    }